import cn from 'classnames';
import React from 'react';

import MaxWidth from '../layout/MaxWidth';

enum ESectionWrapperVariant {
  Normal,
  Large,
}

type TSectionWrapper = React.HTMLAttributes<HTMLElement> & {
  children: React.ReactNode;
  variant?: ESectionWrapperVariant;
  maxWidthClassname?: string;
};

export const SectionWrapper: React.FC<TSectionWrapper> = ({
  children,
  variant = ESectionWrapperVariant.Normal,
  maxWidthClassname,
  ...rest
}) => {
  return (
    <section {...rest}>
      <MaxWidth
        className={cn('mx-auto max-w-xxxxl', maxWidthClassname, {
          'px-6 lg:px-20': variant === ESectionWrapperVariant.Normal,
          'px-0': variant === ESectionWrapperVariant.Large,
        })}>
        {children}
      </MaxWidth>
    </section>
  );
};
